import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import SuccessAlert from '../child/Alert/SuccessAlert';
import DengerAlert from '../child/Alert/DengerAlert';
import { saveAs } from "file-saver"; // Ensure file-saver is installed
import Papa from "papaparse";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; 
import ExcelJS from 'exceljs';

import { handleUnauthorized,showConfirmationDialog} from '../../utils/apiHelper';

const UserListLayer = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Dynamically adjustable items per page
  const [selectedItems, setSelectedItems] = useState([]); // Track selected items
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
    const [selectedExport, setSelectedExport] = useState(""); 
  const navigate = useNavigate();
  
   // Sorting states
   const [sortColumn, setSortColumn] = useState("createdAt");
   const [sortOrder, setSortOrder] = useState("desc");

  const authToken = localStorage.getItem('authToken');
 
  const storedPermissions = JSON.parse(localStorage.getItem("permissions") || "[]");

  // Find permissions for the "Host Individual" module
  const hostIndividualPermissions = storedPermissions.find(
    (perm) => perm.moduleName === "User"
  );
  
  // Define permission variables
  const canView = hostIndividualPermissions?.view || false;
  const canDelete = hostIndividualPermissions?.delete || false;
  
  const userrole = localStorage.getItem("user_role");
    useEffect(() => {
      fetchData(currentPage);
     
    }, [currentPage, searchQuery, itemsPerPage,sortOrder,sortColumn]);
    const fetchData = async (page) => {
     
        const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/userList?page=${page}&limit=${itemsPerPage}&sort=${sortColumn}&order=${sortOrder}&search=${searchQuery}`;
        try {
          setLoading(true);
          const response = await fetch(API_ENDPOINT, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authToken}`,
            },
          });
          if (response.status === 401) {
            handleUnauthorized(navigate);;
            return;
          }
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();

          setItems(data.users || []);
         setTotalItems(data.metadata.totalUsers || 0);
          setTotalPages(data.metadata.totalPages || 1);
        } catch (error) {
          setItems([]);
        } finally {
          setLoading(false);
        }
      };
      const handlePageChange = (pageNumber) => {
        //alert(pageNumber);
        if (pageNumber >= 1 && pageNumber <= totalPages) {
          setCurrentPage(pageNumber);
          //fetchData(pageNumber);
        }
      };
      const handleItemsPerPageChange = (e) => {
        //alert(e.target.value);
        setItemsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to the first page on items per page change
      };
      // Handle sorting when column is clicked
      const handleSort = (column) => {
      
        setSortColumn(column);
        setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
      };
      const updateStatus = async (id, currentStatus) => {
        const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
        const message = `Do you want to change the status to ${newStatus}?`;
        const result = await showConfirmationDialog(message);
        if (result.isConfirmed) {
          try {
            const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/userUpdate/${id}`;
            const response = await fetch(API_ENDPOINT, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authToken}`,
               
              },
              body: JSON.stringify({ status: newStatus }),
            });
            if (response.status === 401) {
              handleUnauthorized(navigate);;
              return;
            }
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            setSuccessMessage('User status updated successfully!');
          setTimeout(() => {
            setSuccessMessage("");
           //window.location.reload();
          }, 3000);
         
            fetchData(currentPage);
          } catch (error) {
            setErrorMessage(error.message);
            setTimeout(() => {
              setErrorMessage("");
            }, 3000);
                }
        }
      };
      const handleSelectAll = (e) => {
        if (e.target.checked) {
          setSelectedItems(items.map(item => item._id));
        } else {
          setSelectedItems([]);
        }
      };
         const handleExportChange = async (event) => {
                    const exportType = event.target.value;
                    setSelectedExport(exportType);
                    if (exportType === "csv") {
                        const dataToExport =
                          selectedItems.length > 0
                            ? items.filter(item => selectedItems.includes(item._id))
                            : items;
                        if (dataToExport.length === 0) {
                          setErrorMessage("No data available to export.");
                          return;
                        }
                        const csvData = dataToExport.map(item => {
                          const date = new Date(item.createdAt);
                          const day = String(date.getDate()).padStart(2, '0');
                          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                          const year = String(date.getFullYear());
                          
                          const formattedDate = `${day}-${month}-${year}`;
                              return{
                                "Name": item.fullName || 'N/A',
                                "Email":  item.email || 'N/A',
                                "Status":  item.status.charAt(0).toUpperCase() + item.status.slice(1) || 'N/A',
                                "Date":  formattedDate,
                              }
                         
                        });
                        const csv = Papa.unparse(csvData);
                        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `user_${new Date().toISOString().slice(0, 10)}.csv`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        
                  }
                  if(exportType === "excel")
                  {
                     const dataToExport =
                            selectedItems.length > 0
                              ? items.filter(item => selectedItems.includes(item._id))
                              : items;
                    
                          if (dataToExport.length === 0) {
                            setErrorMessage("No data available to export.");
                            return;
                          }
                    
                            const workbook = new ExcelJS.Workbook();
                            const worksheet = workbook.addWorksheet('user');
                    
                            // Header
                            const headerRow = worksheet.addRow(["Name", "Email", "Status", "Date"]);
                            headerRow.eachCell(cell => {
                              cell.font = { bold: true };
                            });
                    
                            dataToExport.forEach(item => {
                              const date = new Date(item.createdAt);
                              const day = String(date.getDate()).padStart(2, '0');
                              const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                              const year = String(date.getFullYear());
                              
                              const formattedDate = `${day}-${month}-${year}`;
                              worksheet.addRow([
                                item.fullName || 'N/A',
                                item.email|| 'N/A',
                                item.status.charAt(0).toUpperCase() + item.status.slice(1) || 'N/A',
                                formattedDate,
                              ]);
                            });
                    
                            const buffer = await workbook.xlsx.writeBuffer();
                            const blob = new Blob([buffer], {
                              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            });
                            saveAs(blob, `user${new Date().toISOString().slice(0, 10)}.xlsx`);
                    

                    
                  }
                  if(exportType === 'pdf')
                  {
                    const dataToExport =
                    selectedItems.length > 0
                      ? items.filter(item => selectedItems.includes(item._id))
                      : items;
                
                  if (dataToExport.length === 0) {
                    setErrorMessage("No data available to export.");
                    return;
                  }
                
                  const pdf = new jsPDF();
                
                  // Title
                  pdf.setFontSize(18);
                  pdf.text("user Report", 14, 15);
                
                  // Table headers
                  const headers = ["Name", "Email", "Date","Status"];
                  
                  const rows = dataToExport.map(item => {
                    const date = new Date(item.createdAt);
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                    const year = String(date.getFullYear());
                    
                    const formattedDate = `${day}-${month}-${year}`;
                  
                    return [
                      item.fullName || "N/A",
                      item.email || "N/A",
                      formattedDate,
                      item.status.charAt(0).toUpperCase() + item.status.slice(1) || "N/A"
                    ];
                  });
                
                  // Use autoTable correctly
                  autoTable(pdf, {
                    head: [headers],
                    body: rows,
                    headStyles: {
                      fillColor: "#5e157e", // RGB color for the header background (e.g., blue)
                      textColor: [255, 255, 255], // White text color
                      fontStyle: "bold",
                    },
                    startY: 25, // Position table below title
                  });
                
                  // Save PDF
                  pdf.save(`user_${new Date().toISOString().slice(0, 10)}.pdf`);
                
                  }
                }
      const getPaginationRange = () => {
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + 4); // Ensure only 5 items are shown (start + 4)
      
        if (end - start < 4) {
          start = Math.max(1, end - 4);
        }
      
        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
      };
      const handleSelectItem = (id) => {
        setSelectedItems((prevSelected) => {
          if (prevSelected.includes(id)) {
            return prevSelected.filter((item) => item !== id);
          } else {
            return [...prevSelected, id];
          }
        });
      };
      const handleNext = () => {
        if (currentPage < totalPages) {
          setCurrentPage((prev) => prev + 1);
        }
      };
      
      const handlePrev = () => {
        if (currentPage > 1) {
          setCurrentPage((prev) => prev - 1);
        }
      };
         const isSelected = (id) => selectedItems.includes(id);
         const handleDeleteAll = async (id,single='No') => {
           const idsToDelete = single === 'Yes' ? [id] : selectedItems;
           if (idsToDelete.length === 0) {
             return;
           }
           if(idsToDelete.length == 1)
           {
             single='Yes';
           }
           const message = `This action will delete the user!`;
           const confirmmessage = `Yes, delete it!`;
           const result = await showConfirmationDialog(message, confirmmessage);
     
           if (!result.isConfirmed) return;
     
           try {
             const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/userDelete`;
             const response = await fetch(API_ENDPOINT, {
               method: 'DELETE',
               headers: {
                 'Content-Type': 'application/json',
                 Authorization: `Bearer ${authToken}`,
               },
               body: JSON.stringify({ id: idsToDelete }), // Ensure this is only an array of IDs
             });
             
             if (response.status === 401) {
               handleUnauthorized(navigate);;
               return;
             }
            
             if (!response.ok) {
               throw new Error(`HTTP error! status: ${response.status}`);
             }
             const successmessage = single === 'Yes' ? 'User deleted successfully!' : 'User deleted successfully!';
             setSuccessMessage(successmessage);
             setTimeout(() => {
               setSuccessMessage("");
              //window.location.reload();
             }, 3000);
   
           
     
             if (single === 'No') {
               setSelectedItems([]);
             }
             fetchData(currentPage);
           } catch (error) {
             setErrorMessage(error.message);
               setTimeout(() => {
                 setErrorMessage("");
               }, 3000);
                 //  }
           }
         };
     
    return (
        <div className="card h-100 p-0 radius-12">
            {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
            {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex align-items-center flex-wrap gap-3">
                    <span className="text-md fw-medium text-secondary-light mb-0"  
                   >Show</span>
                    <select className="form-select form-select-sm w-auto ps-12 py-6"    style={{fontSize:"16px", borderRadius:"7px" , backgroundPositionX: "unset", backgroundPosition: "right 0.75rem center" }}  value={itemsPerPage} defaultValue="Select Number"  onChange={handleItemsPerPageChange}>   
                        <option value="10">10 items per page</option>
                        <option value="20">20 items per page</option>
                        <option value="50">50 items per page</option>
                        <option value="100">100 items per page</option>
                    </select>
                    <form className="navbar-search" style={{ position: "relative" }}>
                      <input
                        type="text"
                        className="bg-base h-40-px w-auto pe-40" // pe-40 = padding end for space to right-side icons
                        name="search"
                        placeholder="Search by Name or Email"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyUp={(e) => {
                          if (e.target.value === "") {
                            setCurrentPage(1);
                          }
                        }}
                        style={{
                          paddingRight: searchQuery ? "5rem" : "2.5rem", // more space if clear icon shows
                        }}
                      />

                      {/* Search Icon */}
                      <Icon
                        icon="ion:search-outline"
                        className="icon"
                        style={{
                          position: "absolute",
                          right: searchQuery ? "3.25rem" : "1rem",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "1.25rem",
                          color: "#999",
                          pointerEvents: "none",
                        }}
                      />

                      {/* Clear (Close) Icon */}
                      {searchQuery && (
                        <button
                          type="button"
                          onClick={() => {
                            setSearchQuery("");
                            setCurrentPage(1);
                          }}
                          style={{
                            position: "absolute",
                            right: "1rem",
                             top: "30%",
                            transform: "translateY(-50%)",
                            fontSize: "1.25rem",
                            color: "#000",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          <Icon icon="ic:round-close" />
                        </button>
                      )}
                    </form>

                  
                    <button className="btn btn-danger" onClick={handleDeleteAll} disabled={selectedItems.length === 0}>
                        Delete All
                    </button>
                 
                     <select className="form-select form-select-sm w-auto ps-12 py-6" value={selectedExport} onChange={handleExportChange}
  style={{ padding:"2.5625rem 2.875rem 0.5625rem 0.9375rem",fontSize:"16px",borderRadius:"7px",backgroundPositionX: "unset", backgroundPosition: "right 0.75rem center",fontSize:"16px" }} >   
                        <option value="" disable>Export </option>
                        <option value="pdf">PDF</option>
                        <option value="excel">Excel</option>
                        <option value="csv">CSV</option>
                    </select>
                </div>
                
            </div>
            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                           
                                <th scope="col">
                                    <div className="d-flex align-items-center gap-10">
                                        <div className="form-check style-check d-flex align-items-center">
                                            <input
                                                className="form-check-input radius-4 border input-form-dark"
                                                type="checkbox"
                                                name="checkbox"
                                                id="selectAll"
                                                onChange={handleSelectAll}
                                                checked={selectedItems.length === items.length && items.length > 0}
                                            />
                                        </div>
                                    
                                    </div>
                                </th>
                    
                              
                                <th onClick={() => handleSort("fullName")} style={{ cursor: "pointer" }}>
                                  Name 
                                  <span className="sort-colume">
                                    <Icon icon="mdi:arrow-up" className={`arrow ${sortColumn === "fullName" && sortOrder === "asc" ? "active" : ""}`} />
                                    <Icon icon="mdi:arrow-down" className={`arrow ${sortColumn === "fullName" && sortOrder === "desc" ? "active" : ""}`} />
                                  </span>
                                </th>
                              <th onClick={() => handleSort("email")} style={{ cursor: "pointer" }}>
                                  Email{" "}
                                  <span className="sort-colume">
                                    <Icon icon="mdi:arrow-up" className={`arrow ${sortColumn === "email" && sortOrder === "asc" ? "active" : ""}`} />
                                    <Icon icon="mdi:arrow-down" className={`arrow ${sortColumn === "email" && sortOrder === "desc" ? "active" : ""}`} />
                                  </span>
                                </th>
                                <th onClick={() => handleSort("createdAt")} style={{ cursor: "pointer" }}>
                                  Date{" "}
                                  <span className="sort-colume">
                                    <Icon icon="mdi:arrow-up" className={`arrow ${sortColumn === "createdAt" && sortOrder === "asc" ? "active" : ""}`} />
                                    <Icon icon="mdi:arrow-down" className={`arrow ${sortColumn === "createdAt" && sortOrder === "desc" ? "active" : ""}`} />
                                  </span>
                                </th>
                                <th scope="col" >Status</th>
                                <th scope="col" >Actions</th>
                              
                            </tr>
                        </thead>
                        <tbody>
                         {loading ? (
                                                    <tr>
                                                      <td colSpan="5" className="text-center">
                                                        <span className="loader-15"></span>
                                                      </td>
                                                    </tr>
                                                  ) : items.length > 0 ? (
                                                    items.map((item, index) => {
                                                      const date = new Date(item.createdAt);
                                                      const day = String(date.getDate()).padStart(2, '0');
                                                      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                                                      const year = String(date.getFullYear());
                                                      
                                                      const formattedDate = `${day}-${month}-${year}`;
                                                      return (
                                                        <tr key={item._id}>
                                                         
                                                            <td>
                                                              <div className="d-flex align-items-center gap-10">
                                                                <div className="form-check style-check d-flex align-items-center">
                                                                  <input
                                                                    className="form-check-input radius-4 border border-neutral-400"
                                                                    type="checkbox"
                                                                    name="checkbox"
                                                                    value={item._id}
                                                                    checked={isSelected(item._id)}
                                                                    onChange={() => handleSelectItem(item._id)}
                                                                  />
                                                                </div>
                                                              </div>
                                                            </td>
                                                        
                                                          <td>
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                              {item.fullName || 'N/A'}
                                                            </span>
                                                          </td>
                                                          <td>
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                              {item.email || 'N/A'}
                                                            </span>
                                                          </td>
                                                          <td>{formattedDate}</td>
                                                          <td>
                                                            <span
                                                              onClick={() => updateStatus(item._id, item.status)}
                                                              className={`${
                                                                item.status === 'active'
                                                                  ? 'bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm'
                                                                  : item.status === 'inactive'
                                                                  ? 'bg-neutral-200 text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm'
                                                                  : 'bg-warning'
                                                              }`}
                                                              style={{ cursor: 'pointer' }}
                                                            >
                                                              {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                                            </span>
                                                          </td>
                                                          <td>
                                                            <div className="d-flex align-items-center gap-10">
                                                             
                                                                <button
                                                                  type="button"
                                                                  onClick={() => navigate(`/user/view-user/${item._id}`)}
                                                                  title="View"
                                                                  className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                >
                                                                  <Icon icon="majesticons:eye-line" className="icon text-xl" />
                                                                </button>
                                                             
                                                             
                                                                <button
                                                                  type="button"
                                                                  title="Delete"
                                                                  className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                  onClick={() => handleDeleteAll(item._id, 'Yes')}
                                                                >
                                                                  <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                                                                </button>
                                                             
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      );
                                                    })
                                                  ) : (
                                                    <tr>
                                                      <td colSpan="5" className="text-center">No Data Found</td>
                                                    </tr>
                                                  )}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                  <span>
                  Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                  </span>
                  <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <Link
                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                        to="#"
                        onClick={handlePrev}
                      >
                        <Icon icon="ep:d-arrow-left" />
                      </Link>
                    </li>
                    {getPaginationRange().map((page) => {
                      

                      // Return JSX for pagination items
                      return (
                        <li key={page} className="page-item">
                          <Link
                            className={`page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === page ? "bg-primary-600 text-white" : "bg-neutral-200"}`}
                            to="#"
                            onClick={() => handlePageChange(page)}
                          >
                            {page}
                          </Link>
                        </li>
                      );
                    })}

                 
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                   
                      <Link
                        className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                        to="#"
                        onClick={handleNext}
                      >
                        <Icon icon="ep:d-arrow-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
                </div>
        </div>

    );
};

export default UserListLayer;